import getDisplayMedia, { currentTabID } from '../common/capture/get-display-media';
import RtcError from '../common/rtc-error';
import ErrorCode from '../common/error-code';
import { LocalVideoTrack } from './local-video-track';
import { CaptureOption, MediaType, ScreenCaptureOption, VideoContentHint } from '..';
import { VideoManager } from '../manager/video-manager';
import { after } from '../utils/decorators/middleware';
import innerEmitter from '../inner-emitter/inner-emitter';
import INNER_EVENT from '../inner-emitter/inner-event';
import { performanceNow } from '../utils/utils';
export class LocalScreenTrack extends LocalVideoTrack {
  profile = {
    width: 1920,
    height: 1080,
    frameRate: 5,
    bitrate: 1600
  };
  objectFit: 'contain' | 'cover' | 'fill' = 'contain';
  isScreen = true;

  get isShareCurrentTab() {
    try {
      // @ts-ignore
      return currentTabID === this.mediaTrack?.getCaptureHandle()?.handle;
    } catch {
      return undefined;
    }
  }

  constructor(vm?: VideoManager) {
    super(vm, MediaType.AUX_VIDEO);
    this._log.id = `s-${this._log.id}`;
  }

  @after(function (this: LocalScreenTrack, option: CaptureOption) {
    // 主流默认流畅度优先、辅流默认清晰度优先
    this.setContentHint(option.contentHint || VideoContentHint.DETAIL);
  })
  async capture({ systemAudio = false, autoGainControl, echoCancellation, noiseSuppression, audioTrack, videoTrack, captureElement, preferDisplaySurface, selfBrowserSurface }: ScreenCaptureOption) {
    try {
      const captureStartTime = performanceNow();
      let mediaStream;
      if (videoTrack || audioTrack) {
        mediaStream = new MediaStream();
        if (videoTrack) {
          mediaStream.addTrack(videoTrack);
        }
        if (audioTrack) {
          mediaStream.addTrack(audioTrack);
        }
      } else {
        mediaStream = await getDisplayMedia({
          audio: false,
          systemAudio,
          width: this.profile.width,
          height: this.profile.height,
          frameRate: this.profile.frameRate,
          autoGainControl,
          echoCancellation,
          noiseSuppression,
          captureElement,
          preferDisplaySurface,
          selfBrowserSurface
        });
        this.sourceTrack = mediaStream.getVideoTracks()[0];
      }
      await this.setInputMediaStreamTrack(mediaStream.getVideoTracks()[0]);
      innerEmitter.emit(INNER_EVENT.LOCAL_TRACK_CAPTURE_SUCCESS, { track: this, cost: performanceNow() - captureStartTime, profile: this.profile, room: this.manager?.room });
      return mediaStream;
    } catch (error: any) {
      this.log.error(`getDisplayMedia error observed ${error}`);
      throw error instanceof RtcError
        ? error
        : new RtcError({
          code: ErrorCode.INITIALIZE_FAILED,
          name: error.name,
          message: error.message
        });
    }
  }

  async switchDevice(deviceId: string) {
    throw new Error('Method not implemented.');
  }
}
